import { TThunkAction } from '../../../../common/types/thunk';
import { openTopUpBalance } from '../../../actions/webview';
import { selectTotalAmount } from '../../../selectors/checkoutInfo';
import { EAccountType } from '../../../types/reducers/user';
import { selectBillingUserType } from '../../../selectors/billingInfo';
import { openPaymentModalThunk } from '../openPaymentModal';

export const topUpBalanceThunk =
  (isMicrofrontend: boolean): TThunkAction =>
  (dispatch, getState, context) => {
    const { config, webview } = context;

    const lkSpecialistBaseUrl = config.get<string>('lkSpecialist.baseUrl');

    const state = getState();
    const totalPrice = selectTotalAmount(state);
    const billingUserType = selectBillingUserType(state);

    // Запускаем нативное пополнение счёта в режиме Webview
    if (!isMicrofrontend) {
      webview.sendAction(openTopUpBalance(totalPrice.price));

      return;
    }

    // Юрлицу открываем Кошелёк в ЛК Специалиста
    if (billingUserType === EAccountType.Legal) {
      const url = `${lkSpecialistBaseUrl}/pay`;

      window.open(url, '_blank');

      return;
    }

    // Открываем модалку пополнения счёта в остальных случаях
    dispatch(openPaymentModalThunk(1000));
  };
